import _Menu from "@arco-design/web-react/es/Menu";
import _Affix from "@arco-design/web-react/es/Affix";
import _Layout from "@arco-design/web-react/es/Layout";
import React from 'react';
import { useHistory, useLocation } from 'react-router';
import Search from './search';
import style from './style.less';
import locale from '../../setting/locale';
import useLocale from '@src/hooks/useLocale';
import usePreviewVersion from '@src/hooks/usePrviewVersion';
import useFromQuery from '@src/hooks/useFromQuery';
export default function SideMenu(props) {
  var _a;
  var t = useLocale(locale).t;
  var location = useLocation();
  var history = useHistory();
  var _b = props.routers,
    routers = _b === void 0 ? {} : _b;
  var baseUrl = props.baseUrl;
  var groups = Object.keys(routers);
  var defaultOpenKeys = (_a = location.pathname) === null || _a === void 0 ? void 0 : _a.replace(baseUrl, '').split('/').slice(0, -1);
  defaultOpenKeys.push(defaultOpenKeys.join('/'));
  var _c = usePreviewVersion(),
    isPreview = _c.isPreview,
    currentPreviewVersion = _c.currentPreviewVersion;
  var encodeFrom = useFromQuery();
  return /*#__PURE__*/React.createElement(_Layout.Sider, {
    width: 194,
    className: style['scroll-menu'] + " scroll-menu"
  }, /*#__PURE__*/React.createElement(_Affix, {
    target: function target() {
      return document.querySelector('.scroll-menu > .arco-layout-sider-children');
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Search, {
    routers: routers,
    onSelect: function onSelect(key) {
      if (isPreview) {
        history.push("" + baseUrl + key + "?previewVersion=" + currentPreviewVersion);
      } else {
        history.push("" + baseUrl + key);
      }
    }
  }))), /*#__PURE__*/React.createElement(_Menu, {
    levelIndent: 28,
    autoOpen: true,
    onClickMenuItem: function onClickMenuItem(key) {
      if (!location.pathname.endsWith(key)) {
        if (isPreview) {
          var previewUrl = "?previewVersion=" + currentPreviewVersion + (encodeFrom ? "&" + encodeFrom : encodeFrom);
          history.push(key + ("" + previewUrl));
        } else {
          history.push(encodeFrom ? key + "?" + encodeFrom : key);
        }
      }
    },
    selectedKeys: [location.pathname],
    autoScrollIntoView: true,
    scrollConfig: {
      block: 'center',
      behavior: 'auto'
    }
  }, groups.map(function (key) {
    if (routers[key].items) {
      return /*#__PURE__*/React.createElement(_Menu.SubMenu, {
        title: /*#__PURE__*/React.createElement(React.Fragment, null, routers[key].icon, t[routers[key].i18Key]),
        key: key
      }, routers[key].items.map(function (ele) {
        return ele.items ? /*#__PURE__*/React.createElement(_Menu.ItemGroup, {
          title: t[ele.i18Key],
          key: ele.title
        }, ele.items.map(function (item) {
          return /*#__PURE__*/React.createElement(_Menu.Item, {
            "data-log-click": "{ \"event\": \"config_component\" }",
            "data-log-extra": "{ \"componentName\": \"" + item.key + "\" }",
            key: "" + baseUrl + key + "/" + item.key,
            disabled: item.disabled
          }, item.name || t[item.i18Key]);
        })) : /*#__PURE__*/React.createElement(_Menu.Item, {
          "data-log-click": "{ \"event\": \"config_component\" }",
          "data-log-extra": "{ \"componentName\": \"" + ele.key + "\" }",
          className: "guide-menu-" + ele.key,
          key: "" + baseUrl + key + "/" + ele.key
        }, t[ele.i18Key]);
      }));
    }
    return /*#__PURE__*/React.createElement(_Menu.Item, {
      className: "guide-menu-" + routers[key].key,
      key: "" + baseUrl + routers[key].key
    }, routers[key].icon, t[routers[key].i18Key]);
  })));
}